

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { EnergyDisplay } from '../interfaces';

@Component({
    components: {},
})
export default class SmallDashDisplay extends Vue {

    @Prop() public title!: string;
    private dialog: boolean = false;
    private notifications: boolean = false;
    private sound: boolean = true;
    private widgets: boolean = false;

    public async mounted() {
        return;
    }
}
